import { render, staticRenderFns } from "./corporateBillPaymentLedger.vue?vue&type=template&id=6979dd8e&"
import script from "./corporateBillPaymentLedger.vue?vue&type=script&lang=js&"
export * from "./corporateBillPaymentLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports